import { Box, Checkbox, CheckboxProps, Flex } from '@chakra-ui/react';
import React from 'react';

interface AudioSelectionCheckboxProps {
  disableNext: boolean;
  isChecked: boolean;
  index: number;
}

export const AudioSelectionCheckbox = ({
  disableNext,
  isChecked,
  index: i,
}: AudioSelectionCheckboxProps) => {
  return (
    <Flex
      position="relative"
      justifyContent="center"
      alignItems="center"
      height="full"
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <Checkbox
        isDisabled={disableNext}
        isChecked={isChecked}
        sx={{ '.chakra-checkbox__control': { opacity: 1 } }}
        inputProps={
          {
            'data-testid': `check-audio-${i}`,
          } as CheckboxProps['inputProps']
        }
      />
      {disableNext && (
        <Box
          position="absolute"
          width="24px"
          height="24px"
          data-testid={`checkbox-overlay-${i}`}
        />
      )}
    </Flex>
  );
};
